import { render, staticRenderFns } from "./navbar.component.vue?vue&type=template&id=54b7c321&scoped=true&"
import script from "./navbar.component.js?vue&type=script&lang=js&"
export * from "./navbar.component.js?vue&type=script&lang=js&"
import style0 from "./navbar.component.scss?vue&type=style&index=0&id=54b7c321&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b7c321",
  null
  
)

export default component.exports